<template>
    <v-dialog v-model="getModalTrocaVenda" persistent max-width="960px" transition="dialog-transition" v-if="getModalTrocaVenda">
        <v-card outlined :loading="$store.getters.getOverlay">
            <v-card-title>Troca de Mercadoria</v-card-title>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 md12>
                        <v-text-field label="Nº da Venda" v-model="vendaId" outlined dense class="mt-3 mr-2 ml-2"
                             append-outer-icon="search"
                            @click:append-outer="consultarVenda"
                            @keyup.13="consultarVenda"></v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text v-if="getTrocaVenda.id">
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <td colspan="5">
                                    <h3 class="red--text">Produtos:</h3>
                                </td>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th></th>
                                <th class="text-left">
                                    Cód.
                                </th>
                                <th class="text-left">
                                    Produto
                                </th>
                                <th class="text-left">
                                    Pre. Venda
                                </th>
                                <th class="text-left">
                                    Quant.
                                </th>
                                <th></th>
                                <th class="text-left">
                                    Total
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in getProdutosTrocaVenda" :key="item.id">
                                <td>
                                    <v-checkbox v-model="item.devolver"></v-checkbox>
                                </td>
                                <td>{{ item.produto_id }}</td>
                                <td>{{ item.descricao }}</td>
                                <td>{{ item.preco_venda }}</td>
                                <td>{{ item.quantidade }} </td>
                                <td>
                                    <v-text-field v-if="item.devolver" outlined dense class="mt-5"
                                        v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']"
                                        v-model="item.quantidade_devolvida" @input="verificaQuantidadeDevolvida(item)"
                                        label="QTD. a Devolver" />
                                </td>
                                <td>{{ item.total_venda}}</td>

                            </tr>
                            <tr>
                                <td colspan="6"><b>Subtotal:</b></td>
                                <td>{{getTrocaVenda.subtotal}}</td>
                            </tr>
                            <tr>
                                <td colspan="6"><b>Desconto:</b></td>
                                <td>{{getTrocaVenda.desconto}}</td>
                            </tr>
                            <tr>
                                <td colspan="6"><b>Total:</b></td>
                                <td>{{getTrocaVenda.total}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <td colspan="2">
                                    <h3 class="red--text">Cliente:</h3>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><b>Nome</b></td>
                                <td>{{getTrocaVenda.cliente.nome}}</td>

                            </tr>
                            <tr>
                                <td><b>CPF/CNPJ</b></td>
                                <td>{{getTrocaVenda.cliente.cpf_cnpj}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" outlined :loading="$store.getters.getOverlay" @click="setModalTrocaVenda(false)">
                    Fechar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="warning" @click="setTroca" outlined>Efetuar Troca</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import VendaService from '@/services/VendaService'
    var _ = require('lodash')

    export default {
        components: {
        },
        data() {
            return {
                itens_devolvidos: [],
                vendaId: '',
            }
        },
        computed: {
            ...mapGetters([
                'getModalTrocaVenda',
                'getEmpresaSelecionada',
                'getTrocaVenda',
                'getProdutosTrocaVenda',
                'getVenda',
            ])
        },
        methods: {
            ...mapActions([
                'setModalTrocaVenda',
                'salvarTrocaVenda',
                'consultarTrocaVenda',
                'setModalListarVenda',
                'setTrocaVenda'
            ]),
            verificaQuantidadeDevolvida(item) {
                const verifica = _.debounce(() => {
                    if (this.$helper.cleanFormatReal(item.quantidade_devolvida) > this.$helper.cleanFormatReal(item.quantidade)) {
                        this.$store.commit('alertError', ['A quantidade devolvida não pode ser maior que a quantidade registrada.'])
                        const indexItemVenda = this.getProdutosTrocaVenda.indexOf(item);
                        this.getProdutosTrocaVenda[indexItemVenda].quantidade_devolvida = ''
                        this.getProdutosTrocaVenda[indexItemVenda].devolver = false
                    }
                }, 300)

                verifica();
            },
            consultarVenda() {
                this.consultarTrocaVenda(this.vendaId)
            },
            setTroca(){
                this.$store.commit('setContato', this.getTrocaVenda.cliente)
                this.setTrocaVenda()
            }
        },
        created() {
            this.debounceConsultarVenda = _.debounce(this.consultarVenda, 300)
        }
    }
</script>